import firebase from "firebase";
import { ClientSnapshot } from "@fpd-cloud/schemas/core";
const { fromDate } = firebase.firestore.Timestamp;

export const clientSnapshotConverter = {
  toFirestore(u: ClientSnapshot): firebase.firestore.DocumentData {
    const d: firebase.firestore.DocumentData = { ...u };
    if (u.createdAt) d.createdAt = fromDate(new Date(u.createdAt));
    if (u.updatedAt) d.updatedAt = fromDate(new Date(u.updatedAt));
    return d;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions
  ): ClientSnapshot {
    const data = snapshot.data(options) as ClientSnapshot;
    return {
      ...data,
      createdAt: data.createdAt || new Date(),
      updatedAt: data.updatedAt || new Date()
    };
  }
};
